goog.provide('el8.appchart.mainFeeds.billElationStaffRenderer');

goog.require('el8.service.tooltip');


el8.appchart.mainFeeds.billElationStaffRenderer = (function() {

    return {

        render: function(renderedItem, item) {
            if (!el8Globals.ELATIONSTAFF) { return; }

            var $billError = $('.bill-error-text', renderedItem);

            if ($billError.length) {
                var rawError = item.getBill().getBillingRawError();
                var tooltipText = (rawError) ?
                    'Elation Staff: Click to copy complete error' :
                    'Elation Staff: No detailed error available';
                el8.service.tooltip.create({
                    anchor: $billError,
                    text: tooltipText,
                    placement: 'bottom'
                });
                if (rawError) {
                    // binding directly will make sure this event gets cleaned up
                    // and any event listening cost should be ok since this is for el8staff only
                    $billError.on('click', function() {
                        window.prompt("Copy to clipboard: Ctrl/Cmd+C, Enter", rawError);
                        console.debug(rawError);
                    });
                }
            }
        },

        reset: function(renderedItem) {
            if (!el8Globals.ELATIONSTAFF) { return; }

            var $billError = $('.bill-error-text', renderedItem);
            if ($billError.length) {
                el8.service.tooltip.destroy($billError);
            }
        }

    };

})();